import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-20 bg-[#fafaf9]" data-id="element-259">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-260">
        <div className="max-w-3xl mx-auto" data-id="element-261">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-262">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-[#4a7c2c]/10 rounded-full mb-8" data-id="element-263">
              <Sparkles className="w-7 h-7 text-[#4a7c2c]" data-id="element-264" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-265">
              Ahora imagina esto.
            </h2>

            <div className="space-y-5 text-lg text-gray-600 leading-relaxed text-left" data-id="element-266">
              <p data-id="element-267">
                Es un domingo a la mañana. Sales al patio y ves filas de
                pequeñas plantas que{' '}
                <strong className="text-gray-800" data-id="element-268">
                  tú mismo multiplicaste
                </strong>
                . Cada una es idéntica a su madre. Sanas, vigorosas, listas.
              </p>
              <p data-id="element-269">
                Algunas van a adornar tu casa. Otras las vas a regalar. Y si
                quieres —{' '}
                <strong className="text-gray-800" data-id="element-270">
                  algunas las vas a vender
                </strong>
                .
              </p>
              <p data-id="element-271">
                Tu vecino te pregunta de dónde sacaste tantas plantas. Y tú le
                dices, con naturalidad:{' '}
                <em className="text-[#4a7c2c] font-semibold" data-id="element-272">
                  "Las multipliqué yo."
                </em>
              </p>
            </div>

            <div className="mt-10 bg-white p-6 rounded-2xl shadow-sm border border-[#4a7c2c]/15" data-id="element-273">
              <p className="text-lg font-medium text-gray-800" data-id="element-274">
                Eso no es solo un jardín más lindo. Es una{' '}
                <strong className="text-[#4a7c2c]" data-id="element-275">identidad diferente</strong>.
              </p>
              <p className="text-gray-600 mt-2" data-id="element-276">
                La de alguien que sabe. Que produce. Que tiene el poder de crear
                vida vegetal a voluntad.
              </p>
              <p className="text-[#4a7c2c] font-bold mt-4 text-lg" data-id="element-277">
                Eso es lo que la Guía de Esquejes te da.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}